<template>
	<div class="sa-flexbox" style="padding-bottom: 20px">
		<div class="sa-flexbox-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(createUser)="row">
						<span>{{ row.item.lastname }} {{ row.item.firsname }}</span>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-flexbox-footer" style="background-color: ciano">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import UtilityMixin from "../UtilityMixin";
export default {
	mixins: [UtilityMixin],
	data() {
		return {
			pathResource: "/rsadimissionitrasferimentistatistorico",
			disableCampi: true,
			btnModificaDimissionetrasferimento: true,
			items: [],
			currentPage: 1,
			listKey: 0,
			rows: "",
			perPage: 50,
			fields: [
				{ label: "Stato", key: "stato" },
				{ label: "Note", key: "note" },
				{ label: "Creato da...", key: "createUser" },
				{
					label: "Data e ora",
					key: "dataOra",
					formatter: function (value) {
						return UtilityMixin.methods.formatDateTime(value);
					},
				},
				// { class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		loadData(pathResource, filters) {
			let me = this;
			UtilityMixin.methods.loadDataResources(pathResource, filters, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.$emit("afterLoadData");
			me.items = [];
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
		},
		loadDataError() {},
	},
};
</script>
